import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FileSharingService } from 'shared/services/file-share/file-sharing.service';

@Component({
  selector: 'app-file-upload-box',
  templateUrl: './file-upload-box.component.html',
  styleUrls: ['./file-upload-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileUploadBoxComponent {
  @Input()
  workItemId: string;

  constructor(public fileSharingService: FileSharingService) { }

  sendFileHandler(): void {
    this.fileSharingService.sendFile(this.workItemId);
  }

  closeHandler(): void {
    this.fileSharingService.abortUpload(this.workItemId);
  }

  getFileInfo() {
    return this.fileSharingService.fileMap[this.workItemId];
  }

  isFileUploadBoxVisible(): boolean {
    return !!this.getFileInfo() && !this.fileSharingService.hasErrorMessage(this.workItemId) && !this.fileSharingService.isSendingInProgress(this.workItemId);
  }

  isFileUploadInProgress(): boolean {
    return this.isFileUploadBoxVisible() && !this.fileSharingService.isFileUploaded(this.workItemId);
  }
}
